import { render, staticRenderFns } from "./BgreviewDialog.vue?vue&type=template&id=24721f40&scoped=true&"
import script from "./BgreviewDialog.vue?vue&type=script&lang=js&"
export * from "./BgreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./BgreviewDialog.vue?vue&type=style&index=0&id=24721f40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24721f40",
  null
  
)

export default component.exports